import { type FC } from 'react';

import { SPORT_PLATFORMS_ITEMS } from '@entities/catalog';
import { CatalogSection } from '@widgets/catalog-section';

const SportPlatformsPage: FC = () => (
  <CatalogSection
    title="Спортивные площадки"
    overviewImage="/equipment/sport-platforms/Спортивная площадка.webp"
    overviewSize={{ width: 1600, height: 960 }}
    basePath="/catalog/sport-platforms"
    items={SPORT_PLATFORMS_ITEMS}
  />
);

export default SportPlatformsPage;
